import Splide from "@splidejs/splide";
// import AutoScroll from '@splidejs/splide-extension-auto-scroll';

$(function () {
  if ($(".splide.topMv-slide").length > 0) {
    const splide = new Splide(".splide.topMv-slide", {
      type: "loop",
      arrows: true,
      pagination: true,
      autoplay: true,
    }).mount();

    function updateArrow() {
      const prev = document.querySelector(".splide__arrow--prev");
      const next = document.querySelector(".splide__arrow--next");

      prev.classList.toggle("is-active", splide.index !== 0);
      next.classList.toggle("is-active", splide.index !== splide.length - 1);
    }

    splide.on("mounted move", updateArrow);
  }
});

$(function () {
  if ($(".splide.sec15-slide").length > 0) {
    new Splide(".splide.sec15-slide", {
      type: "loop",
      perPage: 5,
      perMove: 1,
      gap: "20px",
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 3000,

      breakpoints: {
        768: {
          perPage: 1,
          focus: "center",
          padding: "20%",
          gap: "16px",
        }
      }
    }).mount();
  }
});